import { Autocomplete, Box, TextField, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { FieldComponentFont } from '../../Styles/componentStyles';
import { UpperCasePrenomNomFromAuth } from '../../Utils/utils';
// import useGetRequest from '../../hooks/useGetRequest';
// import { axiosPrivate } from '../../Api/axios';
// import { TextFieldComponent } from './ReusableSmallComponents';
const initialUser = {
    'persoData': {
        'nom': 'sélectionner',
        'prenom': ' ...',
    },
    '_id': '1111111111111111111',
};
function SearchUser({ setUser, userType, width,
    userId, selectedAoId, companyId,
    variant, expertsWithRetainedCandidatures, name,esnId, disabled }) {
    SearchUser.propTypes = {
        userType: PropTypes.any,
        userId: PropTypes.any,
        setUser: PropTypes.func,
        companyId: PropTypes.any,
        esnId: PropTypes.any,
        user: PropTypes.any,
        selectedAoId: PropTypes.any,
        //placeholder: PropTypes.any,
        variant: PropTypes.any,
        width: PropTypes.any,
        size: PropTypes.any,
        expertsWithRetainedCandidatures: PropTypes.array,
        name: PropTypes.string,
        disabled: PropTypes.bool,
    };
    const axiosPrivate = useAxiosPrivate();

    // * in case of create mission, we must get experts liked to AO, //TODO : add the scenario ON HE BACKEND: if(selectedAoIdQuery) get only experts where their status are retained
    const selectedAoIdQuery = selectedAoId ? `&selectedAoId=${selectedAoId}` : '';
    const selectedCompanyId = esnId ?`&esnId=${esnId}`:(companyId ? `&companyId=${companyId}` : '');
    const [usersList, setUsersList] = useState([]);
    // ?? { _id: '', porsoData:{nom:'' ,prenom:''}}
    const [userMatchesTheInputUser, setUserMatchesTheInputUser] = useState(initialUser);
    const { errors, showErrors } = useUtilities();
    const { inputSize } = useWindowSize();
    const { i18n } = useTranslation();
    const error = name in errors ? errors[name] : undefined;
    useEffect(() => {
        getUsersList();
    }, [expertsWithRetainedCandidatures, userType, selectedAoIdQuery, selectedCompanyId]);

    useEffect(() => {
        if (usersList && userId) {
            usersList.map((element) => {
                if (element?._id == userId) {
                    // console.log('userId', userId, 'element', element?._id);
                    //let a=element?.persoData?.nom;
                    //{porsoData:{nom:element?.persoData?.nom ,prenom:element?.persoData?.prenom}}
                    setUserMatchesTheInputUser(element);
                    // console.log(element?.persoData?.nom, element?.persoData?.prenom);
                }
            });
        }
    }, [usersList, userId]);
    // useEffect(() => {
    //     if (!companyId) {
    //         setUsersList([]);
    //         setUserMatchesTheInputUser(initialUser);
    //     }
    // }, [companyId]);

    const getUsersList = async () => {
        setUsersList([]);
        setUserMatchesTheInputUser(initialUser);
        setUser(null);
        console.log(4444, {userMatchesTheInputUser, userId, condition: userMatchesTheInputUser == initialUser});
        if (userType !== 'Expert') {
            try {
                const response = await axiosPrivate.get(`/users/searchUser/?userType=${userType}${selectedAoIdQuery}${selectedCompanyId}`);
                setUsersList(response?.data?.searchedUsers ?? []);
            } catch (error) {
                console.log(error);
            }
        }
        else if (userType == 'Expert' && Array.isArray(expertsWithRetainedCandidatures)) {
            setUsersList(expertsWithRetainedCandidatures);
        }
    };
    return (
        <Autocomplete
            id="asynchronous-demo"
            sx={{ width: width || 350 }}
            getOptionLabel={(option) => `${option?.persoData?.nom} ${option?.persoData?.prenom}`}
            options={usersList}
            disabled={disabled}
            freeSolo
            // !
            // value = {userId ? userr : user}
            // value={userr??{ _id: '', porsoData:{nom:'' ,prenom:''}}}
            //value={userMatchesTheInputUser}
            value={userMatchesTheInputUser == initialUser ? null : userMatchesTheInputUser}
            size={inputSize}
            isOptionEqualToValue={(option, value) => option?.persoData?.nom === value?.persoData?.nom}
            onChange={(event, newValue) => {
                // setUser(newValue?._id);
                setUser(newValue);
            }}
            renderOption={(props, usersList) => (
                <Box
                    component='li'
                    {...props}
                    key={usersList?._id}
                >
                    {/* { userName + ' #'+ userId } */}
                    {
                        UpperCasePrenomNomFromAuth(usersList?.persoData?.nom,usersList?.persoData?.prenom)+' '
                    }
                    {
                        userType == 'Expert' ?
                            usersList?.expertId :
                            usersList?.backOfficeId
                    }
                </Box>
            )}
            renderInput={(params) => (
                <ThemeProvider theme={FieldComponentFont}>
                    <TextField
                        {...params}
                        sx={{
                            width: width || '350px',
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                        placeholder={i18n.t('Sélectionner')}
                        variant={variant || 'outlined'}
                        // value={city}
                        // onChange={(event) => onChangeCity(event.target.value)}
                        // label="Ville"
                        //style={{width:'353px',height:'48px',marginTop:'-5px'}}
                        inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off', // disable autocomplete and autofill
                        }}
                        style={{ background: 'white',borderRadius: '8px' }}
                        name={name}
                        helperText={showErrors && (i18n.t(error) ?? '')}
                        error={!!error && showErrors}
                    />
                </ThemeProvider>
            )}
        />
    );
}

export default SearchUser;
{/*
// ! <AutoComplete must have the original TextField and not just the TextFieldComponent for required fields
<TextFieldComponent
                    {...params}
                    sx={{width:width || '350px',
                        '& > :not(style)': {borderRadius: '8px'},
                    }}
                    size={size || 'medium'}
                    placeholder={placeholder || userType}
                    variant={variant || 'outlined'}
                    name={name}
                /> */}